import { Injectable } from '@angular/core';
import { Translation, TranslocoInterceptor } from '@jsverse/transloco';

@Injectable()
export class CustomMergeInterceptor implements TranslocoInterceptor {
  preSaveTranslation(translation: Translation, _lang: string): Translation {
    return translation;
  }

  preSaveTranslationKey(_key: string, value: string, _lang: string): string {
    return value;
  }
}
